export const getCountryUrlPrefix: (countryPrefix: string) => string = (
  countryPrefix,
) => {
  return window.location.hostname.includes("localhost") ||
    window.location.pathname.includes("/dummy/")
    ? ""
    : `/${countryPrefix.toLowerCase()}`;
};
